/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode } from "react";

import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import { PublicIcon } from "@dotnet/telematics-design-system";

import { TABLE_NAMES } from "../../../../../shared";
import { useOverflow } from "../../../../../shared/hooks/useOverflow";
import Tooltip from "../../../../Tooltip/Tooltip";
import { useStyles } from "../../../styles";

interface ScheduleCardTitleProps {
  titleWidth: string;
  resourceName: TABLE_NAMES;
  scheduleName: string;
  globalLinkIcon?: ReactNode;
  globalLinkTooltip?: string;
  isGlobal: boolean;
}

const ScheduleCardTitle = ({
  titleWidth,
  resourceName,
  scheduleName,
  globalLinkIcon,
  globalLinkTooltip,
  isGlobal
}: ScheduleCardTitleProps) => {
  const { t } = useTranslation();
  const { measuredRef, isOverflowing } = useOverflow([]);

  const { scheduleTitle, globalScheduleInfo, scheduleIconAndTitle } =
    useStyles();

  const translatedName = isGlobal ? t("Table##Global schedule") : scheduleName;

  return (
    <div css={css(scheduleIconAndTitle, { maxWidth: titleWidth })}>
      {globalLinkIcon && (
        <Tooltip
          title={globalLinkTooltip}
          size="medium"
          placement="top"
          hasArrow
        >
          <span css={css({ height: "16px" })}>{globalLinkIcon}</span>
        </Tooltip>
      )}

      {isGlobal && (
        <Tooltip
          title={t(`Schedules##global schedule##info##edit schedule`, {
            variableName: resourceName
          })}
          size="medium"
          placement="top"
          hasArrow
        >
          <span>
            <PublicIcon
              css={css(globalScheduleInfo)}
              data-testid="schedules-info-icon"
            />
          </span>
        </Tooltip>
      )}

      <Tooltip
        title={translatedName}
        disableHoverListener={!isOverflowing}
        size="medium"
        placement="top"
      >
        <Typography
          variant="body2Medium"
          css={css([scheduleTitle])}
          ref={measuredRef}
        >
          {translatedName}
        </Typography>
      </Tooltip>
    </div>
  );
};

export default ScheduleCardTitle;
